export default __webpack_public_path__ + "c3f68734e28a6232a94b8d1319d5d2d7.svg";